import { useEffect, useRef, memo } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import icons from '../../assets';
import './dialog.scss';

const { Close } = icons;

const body = document.querySelector('body');

function Dialog({ children, size = 'sm', onHide, backdrop }) {
  const contentRef = useRef(null);
  const classes = cx('dialog-box', {
    'dialog--large': size === 'lg',
    'dialog--medium': size === 'md',
    'dialog--small': size === 'sm',
  });

  useEffect(() => {
    body.classList.add('dialog-open');
    body.style.paddingRight = `${getScrollBarWidth()}px`;
    const dialogModal = document.querySelector("#dialog");
    dialogModal.classList.add('show')
    return () => {
      body.classList.remove('dialog-open');
      body.style.paddingRight = 0;
      dialogModal.classList.remove('show')
    };
  }, []);

  const onDialogHide = () => {
    const dialogModal = document.querySelector("#dialog");
    dialogModal.classList.remove('show')
    onHide?.();
  }

  return ReactDOM.createPortal(
    <>
      <div className="dialog-backdrop" onClick={onDialogHide}></div>
      <div role="dialog" id="dialog" className="dialog fade">
        {
          onHide
          &&
          <button className="dialog-btn" onClick={onHide}>
            <Close style={{ width: 24, height: 24 }} />
          </button>
          
        }
        <div className={classes}>
          <div className="dialog-content" ref={contentRef}>
            {children}
          </div>
        </div>
      </div>
    </>,
    document.querySelector('body')
  );
}

export default memo(Dialog);

function getScrollBarWidth() {
  let el = document.createElement('div');
  el.style.cssText = 'overflow:scroll; visibility:hidden; position:absolute;';
  document.body.appendChild(el);
  let width = el.offsetWidth - el.clientWidth;
  el.remove();
  return width;
}
